import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import ProductCard from 'snippets/product-card/product-card'

export default function ProductCarousel({ products, selector, title, ctaText, ctaLink, enableCenter, options, className }) {
  const optionsDefault = {
    slidesPerView: 2,
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  }

  const currentOptions = options || optionsDefault

  return (
    products.length > 0 && (
      <CarouselSwiper
        children={<ProductItems products={products} />}
        options={currentOptions}
        enableCenter={enableCenter}
        title={title}
        classWrapper={className}
        ctaText={ctaText}
        ctaLink={ctaLink}
        navigation={true}
        selector={selector}
      />
    )
  )
}

function ProductItems({ products }) {
  return products.map(
    (product) =>
      product && (
        <swiper-slide className="h-auto">
          <ProductCard product={product} className="m-0.5 shadow-on-white" />
        </swiper-slide>
      )
  )
}
